import CurrencyDropdown from "components/dropdowns/reactselect/CurrencyDropdown";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React, { useState } from "react";
import { ExchangeRateInput } from "./ExchangeRateInput";

export interface ICurrencyAndExchangeRate {
  currency: server.dto.Currencies
  exchangeRate: number
}

interface CurrencyAndExchangeRatePickerProps {
  validatorKey: string

  bookkeeping: server.dto.BookkeepingSmall
  currency: server.dto.Currencies
  exchangeRate: number

  onChange: (v: ICurrencyAndExchangeRate) => void
  onEsc: () => void;
  onEnter: (v: ICurrencyAndExchangeRate) => void;
  focusOnMount?: boolean
}

export const CurrencyAndExchangeRatePicker = (props: CurrencyAndExchangeRatePickerProps) => {
  const [isFetchingExchangeRate, setIsFetchingExchangeRate] = useState<boolean>(false);

  const refreshExchangeRate = async (currency: server.dto.Currencies) => {
    setIsFetchingExchangeRate(true);
    const r = await window.CoreApi.Bookkeeping.GetExchangeRate(props.bookkeeping.bookkeepingId, currency);
    props.onChange({ currency, exchangeRate: r.data.rate });
    setIsFetchingExchangeRate(false);
  }

  const isExchangeRateVisible = props.bookkeeping.baseCurrency !== props.currency;

  return <div className="flex-column gap-small">
    <CurrencyDropdown
      focusOnMount={props.focusOnMount}
      value={props.currency}
      onChange={(currency) => {
        if (currency !== props.currency) {
          props.onChange({ currency, exchangeRate: props.exchangeRate });
          if (currency !== props.bookkeeping.baseCurrency) {
            refreshExchangeRate(currency);
          }
        }
      }}
      onEsc={() => props.onEsc()}
    />
    {isExchangeRateVisible && <ExchangeRateInput
      value={props.exchangeRate}
      loading={isFetchingExchangeRate}
      onChange={(exchangeRate) => {
        props.onChange({ currency: props.currency, exchangeRate });
      }}
      validatorKey={props.validatorKey}
      currency={props.bookkeeping.baseCurrency}
      onExchangeRateRefresh={() => refreshExchangeRate(props.currency)}
      onEsc={props.onEsc}
      onEnter={(v) => props.onEnter({ currency: props.currency, exchangeRate: v })}
    />}
  </div>
}

interface CurrencyAndExchangeRateDetails {
  bookkeeping: server.dto.BookkeepingSmall
  currency: server.dto.Currency
  exchangeRate: number
}

export const CurrencyAndExchangeRate = (props: CurrencyAndExchangeRateDetails) => {
  const exchangeRateVisible = props.bookkeeping.baseCurrency !== props.currency.value;
  const subLabel = exchangeRateVisible
    ? `${RESX.Financial.ExchangeRate}: ${props.exchangeRate} > ${props.bookkeeping.baseCurrency.toUpperCase()}`
    : undefined;

  return <SmallDetails
    label={`${props.currency.text} (${props.currency.name})`}
    subLabel={subLabel}
  />
}